<template>
  <span>404</span>
</template>

<script>
export default {
  name: 'not-found'
}
</script>



// WEBPACK FOOTER //
// src/default-page/404.vue